import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { object, string } from 'yup';
import { Modal } from '@storable/canaveral-components';
import withForm from '../../../../../admin/hocs/withForm';
import Button from '../../../../../modules/react/components/stateless/Button';
import Icon from '../../../../../modules/react/components/stateless/Icon';
import FormFieldText from '../../../../../admin/components/FormFieldText';
import FormFieldRadio from '../../../../../admin/components/FormFieldRadio';
import linkOptions, { DEFAULT_TARGET } from '../../../../../admin/lib/linkOptions';
import style from './styles.scss';

const validationSchema = object().shape({
  text: string().required('Button text is required'),
  link: string(),
  target: string(),
});

class Editor extends React.Component {
  static propTypes = {
    text: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
    href: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
    onFinishEdit: PropTypes.func.isRequired,
    onCancelEdit: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleReset: PropTypes.func.isRequired,
    className: PropTypes.string,
    target: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
    values: PropTypes.shape({
      text: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
    }).isRequired,
  };

  static defaultProps = {
    text: 'Add Text',
    href: '',
    target: DEFAULT_TARGET,
    className: undefined,
  };

  handleSave = (values) => {
    const { onFinishEdit } = this.props;
    onFinishEdit({ ...values });
  };

  render() {
    const { onCancelEdit, className, handleSubmit, handleReset, values } = this.props;

    return (
      <form onSubmit={handleSubmit} onReset={handleReset}>
        <Modal
          show
          onDismiss={onCancelEdit}
          aria-labelledby="editor"
        >
          <Modal.Header>
            <Modal.Title id="editButtonModal">Button Editor</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs={6} className={style.inputText}>
                <Button
                  className={className || 'color-primary-background'}
                  variant="primary"
                >
                  {values.text || 'customize me'}
                </Button>
              </Col>
              <Col xs={6} className={style.border}>
                <FormFieldText
                  name="text"
                  placeholder="customize me"
                />
              </Col>
            </Row>
            <Row className={style.linkFormControl}>
              <Col xs={1} className={style.link}>
                <Icon id="linkout2" label="Link" className={style.linkIcon} />
              </Col>
              <Col xs={10}>
                <FormFieldText
                  name="href"
                  className={style.linkText}
                  placeholder="Insert link here"
                />
              </Col>
            </Row>
            <Row className={style.radioButtons}>
              <Col xs={4}>
                <FormFieldRadio
                  name="target"
                  className={style.radioButtons}
                  options={linkOptions}
                  inline
                />
              </Col>
              <Col xs={8} className={`text-muted ${style.descriptiveText}`}>
                <div>
                  If you want to link to a page on your website enter:
                </div>
                <div>
                  {'/url-of-your-page'}
                </div>
                <div className={style.smallTop}>
                  If you want to link to another website enter:
                </div>
                <div>
                  {'http://www.domain.com'} or {'https://www.domain.com'}
                </div>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="default" onClick={onCancelEdit}>Cancel</Button>
            <Button type="submit" variant="success" onClick={handleSubmit}>Apply</Button>
          </Modal.Footer>
        </Modal>
      </form>
    );
  }
}

export default withForm({
  mapPropsToValues: ({ text, href, target }) => ({
    text,
    href,
    target,
  }),
  validationSchema,
  handleSubmit: (formPayload, { props }) => props.onFinishEdit({ ...formPayload }),
})(Editor);
